import { useMutation } from "@tanstack/vue-query";

import KiliApi from "@/data/api/kili/kili-api";
import { SecurityMutationKeys } from "@/data/api/kili/security/security-query-keys";
import { TLoginBody } from "@/data/api/kili/security/security.type";

export function useLoginMutation() {
  return useMutation({
    mutationKey: SecurityMutationKeys.login(),
    mutationFn: async (body: TLoginBody) => {
      return KiliApi.login(body);
    },
  });
}
